import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, HashRouter, useLocation } from "react-router-dom";
import Routers, { RenderRoutes } from "./routes/Router";
import { toast } from "react-toastify";

// /bookinclass-admin-react-js/build/
function App() {

useEffect(() => {
    const handleClick = (event) => {
      if (event.target.type === "checkbox" || event.target.type === "button" || event.target.tagName === "BUTTON") {
        return;
      }
      setTimeout(() => {
        toast.dismiss();
      }, 100);
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <>
      <BrowserRouter basename="/">
        <RenderRoutes routers={Routers} />
      </BrowserRouter>
    </>
  );
}

export default App;
